import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import fillterValueReducer from './filter-forms-reducers';
import { baseApi } from './rtk/baseApi';

const reducers = combineReducers({
  form: formReducer,
  filter: fillterValueReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export default reducers;
